/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Audio_Minute_PluralInputs */

const en_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`audio minutes`)
};

const zh_hans1_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频分钟数`)
};

const pt_br2_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutos de áudio`)
};

const es_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutos de audio`)
};

const fr_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutes audio`)
};

const de_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiominuten`)
};

const ru_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`минут аудио`)
};

const it_measure_unit_audio_minute_plural = /** @type {(inputs: Measure_Unit_Audio_Minute_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minuti di audio`)
};

/**
* | output |
* | --- |
* | "audio minutes" |
*
* @param {Measure_Unit_Audio_Minute_PluralInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_audio_minute_plural = /** @type {((inputs?: Measure_Unit_Audio_Minute_PluralInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Audio_Minute_PluralInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_audio_minute_plural(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_audio_minute_plural(inputs)
	if (locale === "es") return es_measure_unit_audio_minute_plural(inputs)
	if (locale === "fr") return fr_measure_unit_audio_minute_plural(inputs)
	if (locale === "de") return de_measure_unit_audio_minute_plural(inputs)
	if (locale === "ru") return ru_measure_unit_audio_minute_plural(inputs)
	if (locale === "it") return it_measure_unit_audio_minute_plural(inputs)
	return en_measure_unit_audio_minute_plural(inputs)
});